import { GeneralUtilities } from "./general";

export class InsurancePolicy {
  public static nexu_rfc = GeneralUtilities.nexu_info.rfc;
  public static nexu_business_name = GeneralUtilities.nexu_info.business_name;
  public static nexu_business_name_invoice = "PRESTEMOS";
  public static nexu_business_name_invoice_complete = "PRESTEMOS SAPI S.A.DE C.V.";
  public static nexu_cve_regimen_fiscal = "14";
  public static nexu_cve_regimen_societario = "5";
  public static nexu_postal_code = GeneralUtilities.nexu_info.postal_code;
  public static nexu_cfdi_use = "G03";
  public static pf_cve_regimen_fiscal = "7";

  public static insurance_info = {
    insurer: "",
    amount: "",
    premium: "",
    policy: "",
  };

  public static insurance_request = {
    product: "",
    sAPaternoAsegurado: undefined,
    sAMaternoAsegurado: undefined,
    sNombreAsegurado: "",
    sRFCAsegurado: "",
    sEmailAsegurado: "",
    sFecNacAsegurado: undefined,
    sTelefono: "",
    sLada: "",
    sNombreConductor: "",
    sAPaternoConductor: undefined,
    sAMaternoConductor: undefined,
    sEmailConductor: "",
    sFecNacConductor: undefined,
    sRFCConductor: "",
    sCodPostal: "",
    sFecInicioVigencia: "",
    sFecFinVigencia: "",
    iCveProducto: "",
    sNumMotor: "",
    sNumSerie: "",
    sIdCotizacionAse: "",
    iCveAseguradora: "",
    iCveTipoPersona: "",
    iCargo_ID: "6",
    CotizacionId: "",
    iCveTipoVenta: "2",
    sCveGiroAse: "",
    sCalle: "",
    sNumExterior: "",
    sNumInterior: "",
    sCelular: undefined,
    sNumPlacas: "",
    sFecInicioFinanciamiento: "",
    sFecFinFinanciamiento: "",
    sRazonSocialAsegurado: undefined,
    sCveGeneroAsegurado: "M",
    sFecConstAsegurado: undefined,
    sCveGeneroConductor: "M",
    numtarjeta: "",
    nombreTitular: undefined,
    apPaternoTitular: undefined,
    apMaternoTitular: undefined,
    sNumPolizaAnt: "",
    iCveEdocCivil: "1",
    cvv: "",
    fechaVencimientoAnio_Tarjeta: "",
    fechaVencimientoMes_Tarjeta: "",
    iRequiereFactura: "0",
    sRFCFactura: undefined,
    sRazonSocialFactura: undefined,
    iCveRegimenSocietario: undefined,
    iCveRegimenFiscal: undefined,
    sCodPostalFiscal: undefined,
    sUsoCFDI: undefined,
  };

  public static parseInsurances = {
    "4": "100123",
    "6": "O1",
    "8": "0020",
    "22": "0000",
    "31": "25741",
  };

  /*
  Translate obtenido de enum back-end
  'moral_people_general' => 'General de Ley personas Morales',
  'moral_people_for_non_profit_purposes' => 'Personas Morales con Fines no Lucrativos',
  'salaries_and_salaries_and_income_assimilated_to_wages' => 'Sueldos y Salarios e Ingresos Asimilados a Salarios',
  'lease' => 'Arrendamiento',
  'disposal_regime_or_acquisition_of_goods' => 'Régimen de Enajenación o Adquisición de Bienes',
  'other_income' => 'Demás ingresos',
  'residents_abroad_without_permanent_establishment_in_mexico' => 'Residentes en el Extranjero sin Establecimiento Permanente en México',
  'dividend_income_partners_and_shareholders' => 'Ingresos por Dividendos (socios y accionistas)',
  'natural_persons_with_business_and_professional_activities' => 'Personas Físicas con Actividades Empresariales y Profesionales',
  'interest_income' => 'Ingresos por intereses',
  'revenue_regime_for_obtaining_prizes' => 'Régimen de los ingresos por obtención de premios',
  'no_tax_obligations' => 'Sin obligaciones fiscales',
  'cooperative_production_societies_that_choose_to_defer_their_income' => 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos',
  'fiscal_incorporation' => 'Incorporación Fiscal',
  'agricultural_livestock_silvicultural_and_fishing_activities' => 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras',
  'optional_for_societies' => 'Opcional para Grupos de Sociedades',
  'coordinated' => 'Coordinados',
  'regime_of_business_activities_with_income_through_technological_platforms' => 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas',
  'simplified_trust_regime' => 'Régimen Simplificado de Confianza'
  */

  //Catálogo obtenido por ordas
  public static parse_fiscal_regime = {
    moral_people_general: "14",
    moral_people_for_non_profit_purposes: "15",
    salaries_and_salaries_and_income_assimilated_to_wages: "1",
    lease: "2",
    disposal_regime_or_acquisition_of_goods: "3",
    other_income: "4",
    residents_abroad_without_permanent_establishment_in_mexico: "5",
    dividend_income_partners_and_shareholders: "6",
    natural_persons_with_business_and_professional_activities: "7",
    interest_income: "8",
    revenue_regime_for_obtaining_prizes: "9",
    no_tax_obligations: "10",
    cooperative_production_societies_that_choose_to_defer_their_income: "16",
    fiscal_incorporation: "11",
    agricultural_livestock_silvicultural_and_fishing_activities: "17",
    optional_for_societies: "18",
    coordinated: "19",
    regime_of_business_activities_with_income_through_technological_platforms: "12",
    simplified_trust_regime: "21",
  };

  public static parseInsuranceData(insurance_request, insurance_selected) {
    insurance_request.product = insurance_selected.product;
    insurance_request.iCveAseguradora = insurance_selected.cve_ase;
    insurance_request.CotizacionId = insurance_selected.cotizacion_id;
    insurance_request.iCveProducto = insurance_selected.id_producto;
    insurance_request.sIdCotizacionAse = insurance_selected.num_cotizacion_ase;
    insurance_request.sCveGiroAse = this.parseInsurances[insurance_selected?.cve_ase] || "0";
  }

  public static parseTitularData(insurance_request, client, email, phone) {
    insurance_request.sEmailAsegurado = email;
    insurance_request.sEmailConductor = email;
    insurance_request.sCelular = phone;
    insurance_request.sTelefono = phone.substr(phone.length - 8);
    insurance_request.sLada = phone.substring(0, 2);
    insurance_request.sAPaternoAsegurado = client.primer_apellido;
    insurance_request.sAPaternoConductor = client.primer_apellido;
    insurance_request.sAMaternoAsegurado = client.segundo_apellido;
    insurance_request.sAMaternoConductor = client.segundo_apellido;
    insurance_request.sNombreConductor = [client.primer_nombre, client.segundo_nombre].join(" ").trim();
    insurance_request.sNombreAsegurado = [client.primer_nombre, client.segundo_nombre].join(" ").trim();
    const raw_birthdate = new Date(client.fecha_nacimiento);
    const userTimezoneOffset = raw_birthdate.getTimezoneOffset() * 60000;
    const birthdate = new Date(raw_birthdate.getTime() + userTimezoneOffset);
    insurance_request.sFecNacAsegurado = this.parseDate(birthdate);
    insurance_request.sFecNacConductor = insurance_request.sFecNacAsegurado;
    if (client?.curp?.[10] === "M") {
      insurance_request.sCveGeneroAsegurado = "F";
      insurance_request.sCveGeneroConductor = "F";
    }
  }

  public static parseContractData(insurance_request, contract_data, client) {
    let rfc = "";
    insurance_request.iRequiereFactura = "1";
    if (insurance_request.product == "credit") {
      rfc = contract_data?.client_call_step?.rfc || client?.rfc || "";
    } else {
      rfc = this.nexu_rfc;
    }
    insurance_request.sRFCAsegurado = rfc;
    insurance_request.sRFCConductor = rfc;
    const regime = client.regime == "pm" ? "moral" : "fisica";
    if (regime == "fisica" && insurance_request.product == "credit") {
      insurance_request.iCveTipoPersona = "1";
    } else {
      insurance_request.iCveTipoPersona = "2";
      if (regime != "fisica") {
        insurance_request.sRazonSocialAsegurado = insurance_request?.sNombreAsegurado;
        insurance_request.sAPaternoAsegurado = undefined;
        insurance_request.sAPaternoConductor = undefined;
        insurance_request.sAMaternoAsegurado = undefined;
        insurance_request.sAMaternoConductor = undefined;
        insurance_request.sFecConstAsegurado = insurance_request?.sFecNacAsegurado;
        insurance_request.sFecNacAsegurado = undefined;
        insurance_request.sFecNacConductor = undefined;
      }
    }
  }

  public static parseAddressData(insurance_request, postal_code, street, street_number) {
    insurance_request.sCodPostal = postal_code;
    insurance_request.sCalle = street;
    insurance_request.sNumExterior = street_number;
    if (insurance_request.iRequiereFactura && !insurance_request.sCodPostalFiscal) {
      insurance_request.sCodPostalFiscal = postal_code;
    }
  }

  public static parseNexuAddressData(insurance_request) {
    insurance_request.sCalle = "Rio Elba";
    insurance_request.sNumExterior = "20";
    insurance_request.sNumInterior = "Piso 15";
    insurance_request.sCodPostal = "06500";
  }

  public static parseNexuData(insurance_request, client, client_email) {
    insurance_request.sEmailAsegurado = "preguntas@nexu.mx";
    insurance_request.sEmailConductor = client_email;
    insurance_request.sTelefono = "99900950";
    insurance_request.sLada = "55";
    insurance_request.sNombreConductor = this.nexu_business_name;
    insurance_request.sNombreAsegurado = this.nexu_business_name;
    insurance_request.sFecConstAsegurado = "20140722";
    insurance_request.sRazonSocialAsegurado = this.nexu_business_name;
    insurance_request.sAPaternoConductor = client.primer_apellido;
    insurance_request.sAMaternoConductor = client.segundo_apellido || " ";
    insurance_request.sNombreConductor = [client.primer_nombre, client.segundo_nombre].join(" ").trim();
    if (client?.curp?.[10] === "M") {
      insurance_request.sCveGeneroConductor = "F";
    }
  }

  public static setInsurancePeriod(insurance_request, signature_date = new Date(), policy_years, product) {
    const start_date = signature_date > new Date() ? signature_date : new Date();
    const slack_days = 1;
    const start_date_slacked = this.addSlackDays(start_date, slack_days);
    const finish_date = this.addYear(start_date_slacked, policy_years);
    insurance_request.sFecInicioVigencia = this.parseDate(start_date_slacked);
    insurance_request.sFecInicioFinanciamiento = this.parseDate(start_date_slacked);
    insurance_request.sFecFinVigencia = this.parseDate(finish_date);
    insurance_request.sFecFinFinanciamiento = this.parseDate(finish_date);
  }

  public static setInvoiceData(insurance_request, invoice_information) {
    if (insurance_request?.product != "credit") {
      insurance_request.iRequiereFactura = "1";
      insurance_request.sRFCFactura = this.nexu_rfc;
      insurance_request.sRazonSocialFactura = this.nexu_business_name_invoice;
      insurance_request.iCveRegimenSocietario = this.nexu_cve_regimen_societario;
      insurance_request.iCveRegimenFiscal = this.nexu_cve_regimen_fiscal;
      insurance_request.sCodPostalFiscal = this.nexu_postal_code;
      insurance_request.sUsoCFDI = this.nexu_cfdi_use;
    } else {
      if (
        invoice_information?.invoice == true &&
        invoice_information?.tax_regime &&
        insurance_request.sRFCAsegurado?.length == 13
      ) {
        insurance_request.iRequiereFactura = "1";
        insurance_request.sRFCFactura = insurance_request.sRFCAsegurado;
        insurance_request.iCveRegimenFiscal = this.parse_fiscal_regime[invoice_information?.tax_regime];
        insurance_request.sCodPostalFiscal =
          invoice_information.fiscal_address?.match(/\d{5}/g)?.pop() || insurance_request.sCodPostal;
        insurance_request.sUsoCFDI = this.nexu_cfdi_use;
      } else {
        insurance_request.iRequiereFactura = "0";
      }
    }
  }

  private static parseDate(date: Date) {
    let parsed = "";
    if (date) {
      const year = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString();
      if (month.length == 1) month = `0${month}`;
      let day = date.getDate().toString();
      if (day.length == 1) day = `0${day}`;
      parsed = year + month + day;
    }
    return parsed;
  }

  private static addYear(date: Date, additional_years: number) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year + additional_years, month, day);
  }

  private static addSlackDays(date: Date, days: number) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    return new Date(year, month, day + days);
  }
}
